import { message, Space, Form as FormInitial, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import reporteCargaCombustiblePdf, { extraerFotosCarga } from "../../../../Pdf/reporteCargaCombustiblePdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class MandarCorreoCargaCombustible extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    pdf: null,
    datos: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.cargarPdf();
    }
  }

  async cargarPdf() {
    const { carga } = this.props;
    if (!carga) return;
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "rendimientos/datosCarga",
        { empresaId: this.props.empresaId, cargaId: carga._id },
        { headers: this.props.headersToken }
      );
      const d = res.data || {};
      const { fotos, omitidas } = extraerFotosCarga(d);
      if (omitidas > 0) {
        message.warning(
          `${omitidas} imagen(es) en formato no soportado (ej. webp) no se incluyeron en el PDF. Usa JPG o PNG.`
        );
      }
      const dd = reporteCargaCombustiblePdf({
        empresa: this.props.empresa,
        vehiculoNombre: this.props.vehiculoNombre || "Vehículo",
        carga: {
          ...d,
          kmRecorridos: carga.kmRecorridos,
          rendimiento: carga.rendimiento,
          factura: d.factura,
        },
        fotos,
      });
      const pdf = pdfMake.createPdf(dd);
      this.setState({ loading: false, pdf, datos: d }, () => {
        try {
          pdf.open({}, window.frames["cargaCombustiblePdf"]);
        } catch (e) {
          message.error("No se pudo mostrar la vista previa: " + e.message);
        }
      });
    } catch (err) {
      this.setState({ loading: false });
      message.error("No se pudo generar el PDF de la carga: " + (err?.message || "error desconocido"));
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (!values?.correosEnvio?.length) {
      return message.info("Proporcione al menos un correo de envío");
    }
    if (!this.state.pdf) {
      return message.error("El PDF aún no está listo");
    }
    this.setState({ loading: true });
    this.state.pdf.getBase64((base64) => {
      axios
        .post(
          "rendimientos/enviarCargaCombustible",
          {
            empresaId: this.props.empresaId,
            cargaId: this.props.carga._id,
            correosEnvio: values.correosEnvio,
            pdfBase64: base64,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data && res.data.success === 2) {
            message.success("Carga enviada por correo");
            this.formRef.current.resetFields();
            this.cerrar();
          } else if (res.data && res.data.success === 1) {
            message.error(res.data.message || "No se pudo enviar la carga");
          } else {
            message.error("Sucedió un error y no se pudo enviar");
          }
        })
        .catch(() => {
          this.setState({ loading: false });
          message.error("Sucedió un error y no se pudo enviar");
        });
    });
  }

  descargar() {
    if (!this.state.pdf) return message.error("El PDF aún no está listo");
    const nombre = `Carga_${this.props.vehiculoNombre || "Vehiculo"}_${moment(
      this.state.datos?.fecha
    ).format("YYYY-MM-DD")}`;
    this.state.pdf.download(nombre + ".pdf");
  }

  cerrar() {
    if (this.formRef.current) this.formRef.current.resetFields();
    this.setState({ pdf: null, datos: null });
    this.props.cerrar();
  }

  render() {
    return (
      <ModalItem
        title="Vista previa — Carga de combustible"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrar.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="mandarCorreoCargaCombustible"
          layout
          width={700}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List name="correosEnvio" initialValue={[{ correo: "" }]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={arrayKey}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: "100%" }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: "center" }}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: "center", marginTop: "5px" }}>
                    <ButtonItem type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem
                type="primary"
                blanco={true}
                onClick={this.descargar.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Descargar
              </ButtonItem>
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrar.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>
        <iframe
          title="cargaCombustiblePdf"
          style={{ width: "100%", height: "100vh" }}
          id="cargaCombustiblePdf"
          name="cargaCombustiblePdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(MandarCorreoCargaCombustible);
